/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocTextIcon20Solid = forwardRef('DocTextIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.004 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7.998h-3.746a2.25 2.25 0 0 1-2.25-2.25V2ZM6.25 14.25A.75.75 0 0 1 7 13.5h2.75a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM7 10.5A.75.75 0 0 0 7 12h6a.75.75 0 0 0 0-1.5H7Z" }),
        React.createElement("path", { d: "m15.863 6.498-4.359-4.359v3.609c0 .414.336.75.75.75h3.61Z" })));
});
